/**
 * Totais por fornecedor (ADR-0078). A cotação é item a item, mas o
 * comprador decide olhando o total de cada fornecedor — como fazia na
 * planilha ("MESTRE= 1.940,00 / MADEIRANIT= 1.798,00").
 *
 * "Mais barato" só entre quem cotou TODOS os itens: quem cotou 1 de 5 teria
 * o menor total sem ser o mais barato.
 */
import React from "react";

import { formatarReaisBR } from "../../../utils/dinheiro";
import { Mono, Tag } from "../_shared/quadro/styles";
import { Rotulo } from "./ui";

export default function QuadroFornecedores({ totais }) {
  const fornecedores = totais?.fornecedores || [];
  if (!fornecedores.length) return null;
  const n = totais.itens;
  return (
    <div>
      <Rotulo>Cotações por fornecedor</Rotulo>
      <div style={{ overflowX: "hidden", border: "1px solid var(--border)", borderRadius: 12 }}>
        <table style={{ width: "100%", tableLayout: "fixed", borderCollapse: "collapse", fontSize: 13 }}>
          <thead>
            <tr style={{ color: "var(--ink-4)", fontSize: 11, textAlign: "left", textTransform: "uppercase", letterSpacing: ".06em" }}>
              <th style={{ padding: "8px 12px", width: "38%" }}>Fornecedor</th>
              <th style={{ padding: "8px 12px" }}>Itens cotados</th>
              <th style={{ padding: "8px 12px", textAlign: "right" }}>Total c/ frete</th>
            </tr>
          </thead>
          <tbody>
            {fornecedores.map((f) => (
              <tr key={f.fornecedor} style={{ borderTop: "1px solid var(--border-subtle, var(--border))" }}>
                <td style={{ padding: "8px 12px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={f.fornecedor_nome}>
                  <span style={{ fontWeight: 600 }}>{f.fornecedor_nome}</span>{" "}
                  {f.mais_barato ? <Tag $tone="success" $h={18}>Mais barato</Tag> : null}
                </td>
                <td style={{ padding: "8px 12px", color: f.cobre_tudo ? "var(--ink)" : "var(--ink-3)" }}>
                  {f.itens_cotados} de {n}
                  {f.itens_sem_estoque ? ` · não tem ${f.itens_sem_estoque}` : ""}
                  {f.itens_vencidos ? ` · venceu ${f.itens_vencidos}` : ""}
                </td>
                <td style={{ padding: "8px 12px", textAlign: "right" }}>
                  <Mono $size={13} style={{ fontWeight: f.mais_barato ? 700 : 500 }}>
                    {f.itens_cotados ? formatarReaisBR(f.total) : "—"}
                  </Mono>
                  {!f.cobre_tudo && f.itens_cotados ? <div style={{ fontSize: 11, color: "var(--ink-4)" }}>parcial</div> : null}
                </td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr style={{ borderTop: "1px solid var(--border)" }}>
              <td style={{ padding: "8px 12px", fontWeight: 600 }}>Total dos vencedores</td>
              <td style={{ padding: "8px 12px", color: "var(--ink-3)" }}>{totais.itens_com_vencedor} de {n} itens</td>
              <td style={{ padding: "8px 12px", textAlign: "right" }}>
                <Mono $size={13} style={{ fontWeight: 700 }}>
                  {totais.itens_com_vencedor ? formatarReaisBR(totais.total_vencedores) : "—"}
                </Mono>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
}
